import React, { useCallback, useEffect, useState } from "react";
import styles from "./boxRangerText.module.scss";
import NumberFormat from "react-number-format";
import { getOnlyNumbers } from "../../common/utils/Utils";
import formatPrice from "../../common/utils/Utils";

export interface BoxRangerTextProps {
  children?: any;
  maxRanger?: number | null;
  minRanger?: number | null;
  onChange?: any;
  defaultValue?: Array<number> | number;
  classname?: string;
  onFocus?: any;
  limitValue?: number;
}
export const TEST_ID = "box-ranger-text-testid";

const FIELD = { MIN: "MIN", MAX: "MAX" };

export const BoxRangerText: React.FC<BoxRangerTextProps> = ({
  children,
  maxRanger,
  minRanger,
  onChange,
  defaultValue,
  classname,
  onFocus,
  limitValue,
}) => {
  const [minNumber, setMinNumber] = useState(minRanger);
  const [maxNumber, setMaxNumber] = useState(maxRanger);
  const [value, setValue] = useState<number[]>([minNumber, maxNumber]);
  const [isFocus, setIsFocus] = useState(false);

  const withValueLimit = ({ floatValue }) => floatValue <= limitValue * 100;

  function format(value: string | number) {
    return Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
      minimumFractionDigits: 2,
    }).format(Number(value) / 100);
  }

  const handleNumberFormat = (action) => {
    const [min, max] = value;

    const minProps = {
      value: min,
      onChange: ({ target: { value } }) => {
        const newValue = value || 0;
        setValue([newValue, max]);
        onChange({
          min: getOnlyNumbers(newValue),
          max: getOnlyNumbers(max),
        });
      },
    };

    const maxProps = {
      value: max,
      onChange: ({ target: { value } }) => {
        const newValue = value || 0;
        setValue([min, newValue]);
        onChange({
          min: getOnlyNumbers(min),
          max: getOnlyNumbers(newValue),
        });
      },
      onFocus: () => {
        onFocus;
        setIsFocus(true);
      },
      placeholder: "Sem limite",
    };

    const props = {
      ...(action === FIELD.MIN ? minProps : maxProps),
    };

    return (
      <NumberFormat
        {...props}
        prefix="R$"
        decimalScale={2}
        decimalSeparator=","
        thousandSeparator="."
        format={format}
        className={styles.box__info__number}
        isAllowed={withValueLimit}
      />
    );
  };

  useEffect(() => {
    if (defaultValue) setValue(defaultValue as number[]);
  }, [defaultValue]);

  return (
    <div data-testid={TEST_ID} className={[classname, styles.box].join(" ")}>
      <div className={styles.box__info}>
        {handleNumberFormat(FIELD.MIN)}
        <span className={styles.divisor}> - </span>
        {handleNumberFormat(FIELD.MAX)}
      </div>
    </div>
  );
};
